// extracted by mini-css-extract-plugin
export default {"description":"style_description__2XKDd","fade-in":"style_fade-in__ORCLT","top":"style_top__4A5Fe","image":"style_image__t2Dks"};